import { useEffect } from "react";
import { queryClient } from "@/lib/queryClient";

// Page sockets are hints; a restored connection/focused tab always re-reads REST.
export function useLiveChatReconciliation() {
  useEffect(() => {
    const refresh = () => {
      void queryClient.invalidateQueries({ predicate: q =>
        typeof q.queryKey[0] === "string" && q.queryKey[0].startsWith("/api/live-chat/") });
    };
    const visible = () => { if (document.visibilityState === "visible") refresh(); };
    window.addEventListener("focus", refresh);
    window.addEventListener("online", refresh);
    document.addEventListener("visibilitychange", visible);
    return () => {
      window.removeEventListener("focus", refresh);
      window.removeEventListener("online", refresh);
      document.removeEventListener("visibilitychange", visible);
    };
  }, []);
}
